module.exports = __webpack_public_path__ + "public/files/img/myreport.1fb908a1.png";